import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { InvitationProvider } from "./contexts/InvitationContext";
import { Navigation } from "./components/layout/Navigation";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { AppErrorBoundary } from "./components/errors/AppErrorBoundary";
import LandingPage from "./pages/LandingPage";
import PricingPage from "./pages/PricingPage";
import CreatePage from "./pages/CreatePage";
import LibraryPage from "./pages/LibraryPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CookiePage from "./pages/CookiePage";
import HelpPage from "./pages/HelpPage";
import "@/App.css";

// Pages that render their own full-screen layout (no nav / no top padding)
const STANDALONE_PATHS = ["/login", "/signup", "/auth/callback"];

// Pages that show the nav but do NOT need the bottom nav padding
// (legal / help pages are top-navigation only)
const LEGAL_PATHS = ["/privacy", "/terms", "/cookies", "/help"];

function AppShell() {
  const location = useLocation();
  const isStandalone = STANDALONE_PATHS.includes(location.pathname);

  return (
    <>
      {!isStandalone && <Navigation />}
      <main className={isStandalone ? "" : "pt-14 md:pt-20"}>
        <Routes>
          {/* ── Core app ── */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route
            path="/library"
            element={
              <ProtectedRoute>
                <LibraryPage />
              </ProtectedRoute>
            }
          />

          {/* ── Legal & Support ── */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookies" element={<CookiePage />} />
          <Route path="/help" element={<HelpPage />} />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <InvitationProvider>
          <AppErrorBoundary>
            <Toaster position="top-right" richColors />
            <AppShell />
          </AppErrorBoundary>
        </InvitationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
